import { useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import type { BlogPostFull, BlogSummary } from "@handvero/shared";
import { api, errorText } from "../api";
import { Prose } from "../components/Prose";
import { Notice, Page, PageHead } from "../components/ui";

const day = (iso: string) => new Date(iso).toLocaleDateString("de-DE", { day: "numeric", month: "long", year: "numeric" });

export function BlogList() {
  const [posts, setPosts] = useState<BlogSummary[] | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    document.title = "Blog – HandVero";
    api.get<BlogSummary[]>("/api/blog").then(setPosts, (e) => setError(errorText(e)));
  }, []);
  return (
    <Page name="blog">
      <div className="wrap stack-lg" style={{ maxWidth: 820 }}>
        <PageHead eyebrow="Blog" title="Neues von HandVero" lead="Gedanken und Neuigkeiten aus dem Erzgebirge: über Handwerk, Ordnung auf der Baustelle und die Arbeit an HandVero." />
        <Notice kind="bad">{error}</Notice>
        {posts && posts.length === 0 && <p className="muted">Noch keine Beiträge. Schauen Sie bald wieder vorbei.</p>}
        <div className="blog-list">
          {posts?.map((p) => (
            <Link key={p.slug} className="blog-card" to={`/blog/${p.slug}`}>
              <span className="mono">{day(p.publishedAt)}</span>
              <h2>{p.title}</h2>
              {p.excerpt && <p>{p.excerpt}</p>}
              <i>Weiterlesen →</i>
            </Link>
          ))}
        </div>
      </div>
    </Page>
  );
}

export function BlogArticle() {
  const { slug } = useParams();
  const [post, setPost] = useState<BlogPostFull | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setPost(null);
    api.get<BlogPostFull>(`/api/blog/${encodeURIComponent(slug ?? "")}`).then(
      (p) => {
        setPost(p);
        document.title = `${p.title} – HandVero`;
      },
      (e) => setError(errorText(e)),
    );
  }, [slug]);
  return (
    <Page name="blog-beitrag">
      <article className="wrap stack-lg" style={{ maxWidth: 720 }}>
        <Link to="/blog" className="muted small">
          ← Alle Beiträge
        </Link>
        <Notice kind="bad">{error}</Notice>
        {post && (
          <>
            <div className="stack">
              <span className="eyebrow">{day(post.publishedAt)}</span>
              <h1>{post.title}</h1>
              {post.excerpt && <p className="lead">{post.excerpt}</p>}
            </div>
            <Prose text={post.body} />
            <div className="cta-band">
              <h2>HandVero kostenlos ausprobieren</h2>
              <Link className="btn btn-primary" to="/registrieren">
                Kostenlos registrieren
              </Link>
            </div>
          </>
        )}
      </article>
    </Page>
  );
}
